import { render } from "./TableActionButton.vue?vue&type=template&id=00979fb1"
import script from "./TableActionButton.vue?vue&type=script&lang=js"
export * from "./TableActionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__